import React from 'react';
import { withStyles } from '@material-ui/core';

import useDesktop from '../../../../hooks/useDesktop';
import Typography from '../../../../components/atomic/Typography';
import PersonalDocumentsRedirect from '../PersonalDocumentsRedirect';
import RedirectOrLogout from '../../../../components/RedirectOrLogout';
import Divider from '../../../../components/atomic/Divider';
import styles from './style';
import newsLetterImage from '../../../../assets/images/boglimappa-newsletter.png';

const NoPropertiesScreen = ({ classes }) => {
  const isDesktop = useDesktop();

  return (
    <>
      <center>
        <img
          src={newsLetterImage}
          className={isDesktop ? classes.imageDesktop : classes.imageMobile}
          alt="boligmappa newsletter"
        />
        <Typography variant="h2">
          Vi fant ingen eiendom registrert på deg.
        </Typography>
        <Divider varient="middle" className={classes.titleDivider} />
        <br />

        <Typography paragraph variant="body1" className={classes.contentText}>
          Boligmappa viser eiendommene du eier. Mangler du{' '}
          {isDesktop ? <br /> : null} en eiendom, kan årsaken være at den er
          tinglyst på {isDesktop ? <br /> : null} andre i familien eller at du
          ikke har blitt tinglyst eier {isDesktop ? <br /> : null} enda.
          Boligmappa fungerer dessverre ikke for aksje-
          {isDesktop ? <br /> : null} eller obligasjonsleiligheter.
        </Typography>

        <Typography paragraph variant="body1" className={classes.contentText}>
          Ønsker du å se dine personlige dokumenter <br /> må du gå til gammel
          løsning.
        </Typography>
        <br />
        <PersonalDocumentsRedirect buttonOnly />
        <RedirectOrLogout />
      </center>
    </>
  );
};

export default withStyles(styles)(NoPropertiesScreen);
